<ion-item lines="none" href="#" detail="false">
    <ion-icon slot="start" [name]="iconName" [src]="iconUrl"></ion-icon>
    <ion-label>
        {{name}}
    </ion-label>
</ion-item>
